<template>
    <div class="info-mosaics-container">       
        <div v-if="paramsCampaignSelected != null">
          <div class="panel-content-title">
            {{ paramsCampaignSelected.campaign_name }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.date }}
          </div>
          <div class="panel-content-header">
            Código
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.campaign_code }}
          </div>
          <div class="panel-content-header">
            Abstract
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.campaign_abstract }}
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.campaign_description }}
          </div>
          <div class="panel-content-header">
            Localización
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.campaign_location }}
          </div>
          <div class="panel-content-header">
            Objetivo
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.campaign_goal }}
          </div>
          <div class="panel-content-title">
            {{ paramsCampaignSelected.name }}
          </div>
          <div class="panel-content-header">
            Descripción de set de datos
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.description }}
          </div>
          <div class="panel-content-header">
            Comentarios de set de datos
          </div>
          <div class="panel-content-line">
            {{ paramsCampaignSelected.comments }}
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'infoPanelParamsDensityMaps',
    computed: {
      paramsCampaignSelected: {
          get () { return this.$store.state.mapLayers.layerParams.paramsCampaignSelected }
      },
    }
  }
</script>

<style scoped>
  .info-mosaics-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-mosaic-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
    margin-bottom: 0.8rem;
  }
  .panel-content-header{
    font-size: small;
    line-height: 100%;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }
  .panel-content-title{
    font-weight: 800;
    margin-bottom: 0.5rem;
    color: #00A7E3;
  }
</style>


// WEBPACK FOOTER //
// src/components/map/InfoPanelParamsDensityMaps.vue